import { render, staticRenderFns } from "./StartChatBtn.vue?vue&type=template&id=28b34492&scoped=true&"
import script from "./StartChatBtn.vue?vue&type=script&lang=js&"
export * from "./StartChatBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b34492",
  null
  
)

export default component.exports